// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"103":"donations","535":"login"}[chunkId] + "." + {"103":"a52f43d4","535":"ab084966"}[chunkId] + ".css";
};